module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAaVBMVEUAAADha2v++fmTqdQMPZ4AM5nw8/nPDw/MAAD88PAPP58JOp2Enc7kh4nuqqqKkL3fZGX20dHh5/NLb7dHbLbXyNbhamr65uYtV6vMf4voior//v76+/3vsbHniYnY3+48Y7H////ODg+cn6E2AAAAAXRSTlMAQObYZgAAAGlJREFUeAGVxYMOA2EYRNGZ2g5qvP8z1TaD6uv8jXaD4iQ3F18R9DkSWcpJJdX6QYSLlBVZ0ia3EBiHSEjVekAn5oUApvCoqLYTj0XfjyCEcdXMANzMAREs6ReVNjkQGfMJwQRwqAz/ewHaDDP9JA9UcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GB.png
// module id = 1143
// module chunks = 0